function byOrder(a, b) {
  return (a.order || 0) - (b.order || 0);
}

/**
 * Build subject→chapter→topic tree from a flat chapters list.
 * Orphans (parentId missing from set) become roots.
 */
export function buildChapterTree(chapters) {
  const map = new Map();
  (chapters || []).forEach((ch) => {
    map.set(ch.id, {
      id: ch.id,
      name: ch.name,
      order: ch.order || 0,
      parentId: ch.parentId ?? null,
      children: [],
    });
  });

  const roots = [];
  map.forEach((node) => {
    if (node.parentId == null || !map.has(node.parentId)) {
      roots.push(node);
    } else {
      map.get(node.parentId).children.push(node);
    }
  });

  const sortRec = (nodes) => {
    nodes.sort(byOrder);
    nodes.forEach((n) => sortRec(n.children));
  };
  sortRec(roots);
  return roots;
}

/** Deepest selected chapter-tree id for content fetch. */
export function activeContentNodeId({ subjectId, chapterId, topicId }) {
  const pick = (v) => (v === '' || v == null ? null : Number(v));
  return pick(topicId) ?? pick(chapterId) ?? pick(subjectId) ?? null;
}
